import React from "react";
import { useControlContext } from "../WControlProvider/ControlContext";
export const ControlErrors = props => {
  const {
    validationErrors
  } = useControlContext();
  const errors = validationErrors || {};
  const messages = Object.keys(errors).map(key => ({
    key,
    value: errors[key]
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, messages.map(message => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: message.key
    }, props.children(message.value, message.key));
  }));
};
export const WControlErrors = () => {
  const {
    control
  } = useControlContext();
  const errors = control && control.errors;
  return /*#__PURE__*/React.createElement("pre", null, errors ? JSON.stringify(errors, null, 2) : "No errors found");
};